module.exports = __webpack_public_path__ + "ff0cec61.svg";